export default __webpack_public_path__ + "static/media/sportplatzgarage_dark.add8ee03.svg";